import { render, staticRenderFns } from "./OpenDiss.vue?vue&type=template&id=470d87a2&scoped=true"
import script from "./OpenDiss.vue?vue&type=script&lang=js"
export * from "./OpenDiss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d87a2",
  null
  
)

export default component.exports